/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './EmprestimoGarantiaCarroCompare.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import RedButton from '@/components/atoms/RedButton';

function EmprestimoGarantiaCarroCompare() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="emp-garantia-carro-compare">
        <ContainerHome24>
          <div className="compare-conteudo">
            <div className="compare-conteudo-textos">
              <h3 className="compare-titulo">Compare e escolha o melhor para o seu bolso</h3>
              <p className="compare-texto">
                O Empréstimo com Garantia de Veículo na Santander Financiamentos pode ser a melhor
                opção para você!
                <br />
                <br className="only-desk" /> Além de maiores chances de aprovação, você conta com
                taxas vantajosas em relação a outros produtos.
              </p>
              <RedButton
                href="https://emprestimosim.com.br/app/#/onboarding/signUp"
                target="_blank"
                className="compare-btn-simular"
              >
                Simular
              </RedButton>
            </div>
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 992 && (
                  <picture className="compare-grafico">
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/grafico-compare.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/grafico-compare.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/grafico-compare.png"
                      alt=""
                      width="288"
                      height="537"
                    />
                  </picture>
                )}
                {width > 992 && (
                  <picture className="compare-grafico">
                    <source
                      type="image/webp"
                      srcSet="assets/emprestimo-garantia-carro/grafico-compare-desk.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="assets/emprestimo-garantia-carro/grafico-compare-desk.png"
                    />
                    <img
                      src="assets/emprestimo-garantia-carro/grafico-compare-desk.png"
                      alt=""
                      width="510"
                      height="451"
                    />
                  </picture>
                )}
              </>
            )}
          </div>
        </ContainerHome24>
      </section>

      <style jsx>{Style}</style>
    </>
  );
}

export default EmprestimoGarantiaCarroCompare;
